















































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';

import { STORE_KEY, store } from './_store';
import EmojiPicker from 'vue-emoji-picker'

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta',
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      text: { required },
    }

    return {
      form: rules
    }
  },
  components: {
    EmojiPicker
  }
})
export default class WAEditForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  loading!: any;
  loaded!: any;
  fatalError!: any;
  document!: any;
  form!: any;

  search: string = '';
  selection: any = null;

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  saveSelection() {
    // @ts-ignore
    if (window.getSelection) {
      // @ts-ignore
      const sel = window.getSelection();
      // @ts-ignore
      if (sel.getRangeAt && sel.rangeCount) {
        // @ts-ignore
        this.selection = sel.getRangeAt(0);
      }
      // @ts-ignore
    } else if (document.selection && document.selection.createRange) {
      // @ts-ignore
      this.selection = document.selection.createRange();
    }
  }

  restoreSelection() {
    if (this.selection) {
      // @ts-ignore
      if (window.getSelection) {
        // @ts-ignore
        const sel = window.getSelection();
        // @ts-ignore
        sel.removeAllRanges();
        // @ts-ignore
        sel.addRange(this.selection);
        // @ts-ignore
      } else if (document.selection && this.selection.select) {
        this.selection.select();
      }
    }
  }


  append(emoji: string) {
    this.restoreSelection()
    this.selection.deleteContents();
    // @ts-ignore
    document.execCommand('insertHtml', false, emoji)
    // @ts-ignore
    window.getSelection().removeAllRanges();
    this.changeValue('text', this.form.text)
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  saveFormData(send: boolean) {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
        if (send) {
          this.$emit('send', this.form.text);
        } else {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
        }
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

